import { useEffect, useRef } from "react";

const VIDEO_CDN = process.env.REACT_APP_PUBLIC_VIDEO_BASE_URL as string;

if (!VIDEO_CDN) {
  throw new Error("REACT_APP_PUBLIC_VIDEO_BASE_URL is not defined");
}

const canPrefetch = () => {
  const conn = (navigator as any)?.connection;
  if (!conn) return true;
  if (conn.saveData) return false;
  return conn.effectiveType !== "2g" && conn.effectiveType !== "slow-2g";
};

export function useHlsPrefetch(videoId?: string | null) {
  const lastIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (!videoId || !canPrefetch()) return;
    if (lastIdRef.current === videoId) return;

    lastIdRef.current = videoId;

    const url = `${VIDEO_CDN.replace(/\/$/, "")}/media/videos/${videoId}/hls/index.m3u8`;

    fetch(url, {
      method: "GET",
      credentials: "omit",
      cache: "force-cache",
    }).catch(() => {
      /* best-effort */
    });
  }, [videoId]);
}